<template>
  <div class="calssify-item">
    <el-dropdown @command="skipMinor" placement="bottom">
      <div class="category-item" @click="skip(item.category_id)">
        <img :src="item.icon+'?x-oss-process=image/resize,m_lfit,h_46,w_46&d=46x46'" class="icon">{{ item.cn_name }}
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="items" v-for="items in item.child" :key="items.category_id">{{ items.cn_name }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
import store from '../lib/local/cart'
// import Vue from '../main';
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
export default {
  props: {
    item: Object,
    show: Boolean
  },
  data() {
    return {
      once: false
    }
  },
  methods: {
    getUrl(id, search) {
      // 决定用location
      const route = window.location
      const localLang = localStorage.getItem('localLang')
      let url
      if (!search) {
        url = `${route.origin}${"/" + localLang}/category/${id}`
      } else {
        url = `${route.origin}${"/" + localLang}/category/${id}?${search}`
      }
      route.href = url
    },
    // 跳转到分类页
    skip(id) {
      this.getUrl(id)
    },
    skipMinor(item) {
      store.commit('DEL_CATEGORY', item.parent_id)
      this.getUrl(item.parent_id, `category_id=${[item.category_id]}`)
    },
  }
}
</script>

<style lang="scss">
.calssify-item {
  width: 3.8rem;
  .category-item {
    cursor: pointer;
    padding: 0.4615rem 0;
    font-size: 0.5385rem;
    .icon {
      width: 1.7692rem;
      height: 1.7692rem;
      border-radius: 50%;
      display: block;
      margin: 0 auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// resources/js/components/classify.vue